const initstate = {
  addressBook: [], // 地址簿
  apiResponse: '',
};

export function shoppingInfoState(state = initstate, action) {
  switch (action.type) {
    case 'GET_ADDRESS_BOOK': {
      return {
        ...state,
        addressBook: action.payload,
      };
    }
    case 'UPDATE_API_RESPONSE': {
      return {
        ...state,
        apiResponse: action.payload,
      };
    }
    default:
      return state;
  }
}

export default shoppingInfoState;
